<template>
    <div class="loginlayout">
        <div v-if="!signupConfirmation" >
            <span class="logintext">{{labels.signUpText}}</span>
            <span class="logintextsubtitle">{{labels.signUpSubTitleText}}
                <router-link to="login">{{labels.loginText}}</router-link>
            </span>
            <div class="loginform">
                <v-form ref="form" v-model="valid"  @keyup.native.enter="valid && signup()" onSubmit="return false;" lazy-validation>
                    <v-layout row>
                        <v-flex xs12>
                            <v-text-field v-model="workEmail" :rules="emailRules" :label="labels.workEmail"  :placeholder="labels.workEmailPlaceholder" @input="validateForm" required ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12>
                            <label id="compnaycountry" class="v-label v-label--active theme--light fieldlabel" >{{labels.companyCountry}}</label>
                            <v-autocomplete
                                v-model="companyCountry"
                                :items="allowedRegistrationCountries"
                                :loading="isLoading"
                                :search-input.sync="search"
                                chips
                                @focus="focusOn"
                                @focusout="focusOut"
                                clearable
                                hide-details
                                hide-selected
                                item-text="countryName"
                                item-value="countryCode"
                                :placeholder="labels.selectPlaceholder"
                                filled
                                solo
                                required
                                @change="validateForm"
                                >
                                <template v-slot:no-data>
                                <span>
                                    {{labels.searchCountry}}
                                </span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span class="flagimage">
                                        <v-img class="flagimage" :src="item.countryFlag"  alt=""/>
                                    </span>
                                    <span class="countrytext" v-text="item.countryName"></span>
                                </template>
                                <template v-slot:item="{ item }">
                                <span class="flagimage">
                                    <v-img class="flagimage" :src="item.countryFlag"  alt=""/>
                                </span>
                                <span class="countrytext">{{item.countryName}} </span>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <br/>
                    <br/>
                    <v-layout>
                        <v-btn block type="submit" v-if="!loadingSignUp" :disabled="!canSignup" color="primary" @click="signup">{{labels.btnNextText}}</v-btn>
                        <div v-if="loadingSignUp" class="text-xs-center" style="width: 100%">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </div>
                    </v-layout>
                </v-form>
            </div>
        </div>
        <div v-if="signupConfirmation" class="confirmationlayout">
            <span class="signupconfirmationtitle">{{labels.checkEmailTitle}}</span>
            <span class="signupconfirmationsubtitle">{{labels.checkEmailSubTitle}} {{workEmail}}  </span>
            <span v-if="showResendUserRegistrationEmail" class="resendLink"><a v-on:click='resendUserRegistrationEmail'>{{labels.resendEmail}}</a></span>
        </div>
    </div>
</template>
<script>
import accountApi from '@/services/AccountApi'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      labels: {
        signUpText: this.$t('Login.SignUp.SIGNUP_TO_THE_DESC', { siteName: `${process.env.VUE_APP_NODE_ENV_API}` }),
        signUpSubTitleText: this.$t('Login.SignUp.SIGN_IN_PROPOSAL'),
        loginText: this.$t('Login.SignUp.SIGN_IN_LINK'),
        workEmail: this.$t('Login.SignUp.WORK_EMAIL_FIELD_NAME') + ' *',
        workEmailPlaceholder: this.$t('Login.SignUp.WORK_EMAIL_PLACEHOLDER'),
        companyCountry: this.$t('Login.SignUp.COMPANY_COUNTRY_FIELD_NAME') + ' *',
        searchCountry: this.$t('Login.SignUp.SEARCH_COUNTRY_DESC'),
        selectPlaceholder: this.$t('Login.SignUp.SELECT_PLACEHOLDER'),
        btnNextText: this.$t('Login.SignUp.NEXT_BTN'),
        checkEmailTitle: this.$t('Login.SignUp.CHECK_EMAIL_TITLE'),
        checkEmailSubTitle: this.$t('Login.SignUp.CHECK_EMAIL_DESC'),
        resendEmail: this.$t('Login.SignUp.RESEND_EMAIL_LINK')
      },
      valid: false,
      isLoading: false,
      canSignup: false,
      search: null,
      loadingSignUp: false,
      workEmail: '',
      companyCountry: '',
      isCompanyCountryHighlighted: false,
      signupConfirmation: false,
      showResendUserRegistrationEmail: true,
      emailRules: [
        v => !!v || '',
        v => /^(?!.*\s)(?!.*<)(?!.*>).+@.+/.test(v) || this.$t('Login.SignUp.WORK_EMAIL_NOT_VALID_ERROR')
      ]
    }
  },
  methods: {
    async signup () {
      try {
        this.loadingSignUp = true
        if (this.$refs.form.validate()) {
          await accountApi.accountRegistration(this.workEmail, this.companyCountry)
          this.signupConfirmation = true
        }
      } finally {
        this.loadingSignUp = false
      }
    },
    async resendUserRegistrationEmail () {
      await accountApi.resendUserRegistrationEmail(this.workEmail)
      this.showResendUserRegistrationEmail = false
      this.$store.dispatch('global/setSnackbar', {
        show: true,
        color: 'success',
        text: this.$t('Login.SignUp.SUCCESSFUL_EMAIL_SENT_DESC'),
        timeout: 6000
      })
    },
    validateForm () {
      this.canSignup = this.$refs.form.validate()
    },
    focusOn () {
      if (!$('#compnaycountry').hasClass('fieldlabelfocused') && !this.isCompanyCountryHighlighted) {
        $('#compnaycountry').addClass('fieldlabelfocused')
      }
    },
    focusOut () {
      if ($('#compnaycountry').hasClass('fieldlabelfocused')) {
        $('#compnaycountry').removeClass('fieldlabelfocused')
      }
      if (this.companyCountry) {
        this.isCompanyCountryHighlighted = false
      } else {
        this.isCompanyCountryHighlighted = true
      }
    }
  },
  computed: {
    ...mapState('countries', ['allowedRegistrationCountries'])
  }
}
</script>
<style scoped>

.resendLink {
    margin: auto;
    display: block;
    text-align: center;
    margin-top: 10px;
}
</style>
